import { getSharedFolders, shareTokenFor } from './ShareLinkApi'
import { axiosInstance } from './axiosInstance'
import { END_POINT_PRODUCT } from './index'

export const getFolders = (projectId) => {
  const shareToken = shareTokenFor(projectId)
  if (shareToken) return getSharedFolders(shareToken)
  return axiosInstance.request({
    method: 'get',
    url: `${END_POINT_PRODUCT}/api/project-folder/${projectId}`,
  })
}
export const deleteFolderRequest = (folderId) => {
  return axiosInstance.request({
    method: 'delete',
    url: `${END_POINT_PRODUCT}/api/project-folder/${folderId}`,
  })
}

export const updateFolder = (folder) => {
  return axiosInstance.request({
    method: 'put',
    url: `${END_POINT_PRODUCT}/api/project-folder`,
    data: folder,
  })
}

export const saveFolder = (folder) => {
  return axiosInstance.request({
    method: 'post',
    url: `${END_POINT_PRODUCT}/api/project-folder`,
    data: folder,
  })
}

// The Drawings organizer's delete: the set's sheets move up a level instead of being deleted.
export const deleteFolderKeepingSheets = (folderId, drawingSetId) => {
  return axiosInstance.request({
    method: 'delete',
    url: `${END_POINT_PRODUCT}/api/project-folder/${folderId}`,
    params: { keepSheets: true, ...(drawingSetId ? { drawingSetId } : {}) },
  })
}
